import React from 'react';

// components
import {CardBorder, LabelContent} from '../../../shared/components';

// helpers
import {useTranslation} from 'react-i18next';
import {formatPhoneNumber} from '../../../shared/helpers';

// styles
import {Subtitle} from '../../../shared/styles';
import {CardPadding, InformationContainer, Separator} from './styles';

type Props = {
  basicInformation: {
    firstname?: string;
    lastname?: string;
    cellphone?: string;
    emailAddress?: string;
  };
};

const Information = ({basicInformation}: Props) => {
  const {t} = useTranslation();
  return (
    <CardBorder variant="white">
      <CardPadding>
        <Subtitle bold="bold">{t('global_information')}</Subtitle>
        <InformationContainer>
          <LabelContent
            label={t('global_firstName')}
            content={basicInformation.firstname ?? '-'}
          />
          <Separator />
          <LabelContent
            label={t('global_lastName')}
            content={basicInformation.lastname ?? '-'}
          />
          <Separator />
          <LabelContent
            label={t('global_phoneNumber')}
            content={
              basicInformation.cellphone
                ? formatPhoneNumber(basicInformation.cellphone)
                : '-'
            }
          />
          <Separator />
          <LabelContent
            label={t('global_email')}
            content={basicInformation.emailAddress ?? '-'}
          />
        </InformationContainer>
      </CardPadding>
    </CardBorder>
  );
};

export default Information;
